import _ from '@lodash';
import { DebounceSettings } from 'lodash';
import { useRef } from 'react';

function useDebounce(func: any, wait?: number, options?: DebounceSettings) {
  return useRef(_.debounce(func, wait, options)).current;
}

export default useDebounce;
